// extracted by mini-css-extract-plugin
module.exports = {"search-results":"AutoCompleteCardSectionCmp_search-results__m4g8K"};